import React, { createContext, ReactNode, useContext, useState } from 'react'

/**
 * What the DOCX export modal is exporting: `null` when the modal is closed,
 * `ALL_CONTROLS` for the whole run, or a control id to export just that one.
 */
export const ALL_CONTROLS = '__all__'
export type DocxExportTarget = string | null

export type ControlTestDocxExportContextType = {
  exportTarget: DocxExportTarget
  openDocxExport: (controlId?: string) => void
  closeDocxExport: () => void
}

const ControlTestDocxExportContext =
  createContext<ControlTestDocxExportContextType>({
    exportTarget: null,
    openDocxExport: () => null,
    closeDocxExport: () => null,
  })

export const ControlTestDocxExportProvider = ({
  children,
}: {
  children: ReactNode
}): JSX.Element => {
  const [exportTarget, setExportTarget] = useState<DocxExportTarget>(null)

  return (
    <ControlTestDocxExportContext.Provider
      value={{
        exportTarget,
        openDocxExport: (controlId?: string) =>
          setExportTarget(controlId || ALL_CONTROLS),
        closeDocxExport: () => setExportTarget(null),
      }}
    >
      {children}
    </ControlTestDocxExportContext.Provider>
  )
}

export const useControlTestDocxExport = (): ControlTestDocxExportContextType =>
  useContext(ControlTestDocxExportContext)
